import TeamMembers from './team/members/TeamMembers'
import TeamMembersView from './team/members/View'
import TeamMembersCreate from './team/members/Create'
import TeamDepartments from './team/departments/Departments'
import TeamDepartmentsView from './team/departments/View'
import TeamDepartmentsCreate from './team/departments/Create'
import SubscriptionRequests from './clients/subscriptions/Requests'
import SubscriptionView from './clients/subscriptions/View'
import NewsletterClients from './clients/newsletter/Clients'
import NewsletterCreate from './clients/newsletter/Create'
import NewsletterView from './clients/newsletter/View'

const Modules = {
    TeamMembers,
    TeamMembersView,
    TeamMembersCreate,
    TeamDepartments,
    TeamDepartmentsView,
    TeamDepartmentsCreate,
    SubscriptionRequests,
    SubscriptionView,
    NewsletterClients,
    NewsletterCreate,
    NewsletterView,
}

export default Modules
